/* eslint react/jsx-indent: 0 */
/* Need to leave this in place because Prettier keeps borking the indentation on commit */

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { filterSummary, filterLoanLease } from '../utils/utility';
import PricingDetail from '../components/PricingDetail';
import PricingLoanLease from '../components/PricingLoanLease';
import PricingSummaryContainer from '../components/PricingSummaryContainer';
import IncentiveModal from '../components/IncentiveModal';
import IncentiveDock from '../components/IncentiveDock';
import InstantEPrice from '../containers/InstantEPrice';
import { PaymentCalculatorButton } from '../components/PaymentCalculatorButton';
import { EPRICE_PENDING } from '../constants/labels';

import '../global-sass/main.scss';

export class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			incentive: {},
			isModalVisible: false,
			isDisplayingEprice: false,
			isScrollingSidebar: false
		};
		this.setModalStateData = this.setModalStateData.bind(this);
		this.showEPrice = this.showEPrice.bind(this);
		this.trackScrollingSidebar = this.trackScrollingSidebar.bind(this);
	}

	componentDidMount() {
		if (this.props.deviceType === 'DESKTOP') {
			window.addEventListener('scroll', this.trackScrollingSidebar);
		}
	}

	componentWillUnmount() {
		if (this.props.deviceType === 'DESKTOP') {
			window.removeEventListener('scroll', this.trackScrollingSidebar);
		}
	}

	setModalStateData(incentive, isModalVisible) {
		this.setState({
			incentive,
			isModalVisible
		});
	}

	showEPrice() {
		this.setState({
			isDisplayingEprice: true
		});
	}

	trackScrollingSidebar() {
		// Tracks whether the sidebar is scrolling or not based on the height set
		this.setState({
			isScrollingSidebar:
				document.querySelector('.vdp-sidebar').style.top.length > 0
		});
	}

	render() {
		const {
			pricing,
			widgetInfo,
			incentiveData,
			windowId,
			widgetName,
			deviceType,
			locale,
			dealerAddress
		} = this.props;
		const { accountId, vehicleAccountId, vehicleType } = widgetInfo;
		const isMobile = deviceType === 'MOBILE';
		let rootComponent;
		if (pricing) {
			let disableInstantEpriceButton = false;

			// This flag is never set to 'false'. Either it's there and set to 'true'
			// or it's simply not delivered from VCDA.
			if (pricing.disableEpriceOnVDP) {
				disableInstantEpriceButton = true;
			}
			// TODO: remove after VCDA release
			else if (pricing.summary) {
				const eprice = pricing.summary.filter(
					x => x.priceType === 'EPRICE'
				)[0];
				const dprice = pricing.summary.filter(
					x => x.priceType === 'DPRICE'
				)[0];
				if (eprice && dprice) {
					disableInstantEpriceButton = !(eprice.value < dprice.value);
				}
			}
			const mobileDialog = (
				<IncentiveDock
					incentive={this.state.incentive}
					isModalVisible={this.state.isModalVisible}
					setModalStateData={this.setModalStateData}
					widgetInfo={{ windowId, widgetName, deviceType }}
				/>
			);
			const regularDialog = (
				<IncentiveModal
					incentive={this.state.incentive}
					isModalVisible={this.state.isModalVisible}
					setModalStateData={this.setModalStateData}
					widgetInfo={{ windowId, widgetName, deviceType }}
				/>
			);
			const detailType =
				pricing.detail.ePrice && this.state.isDisplayingEprice
					? 'ePrice'
					: 'dPrice';

			const summary = filterSummary(pricing.summary, detailType);
			const loanLeaseSummary = filterLoanLease(pricing.summary);

			rootComponent = (
				<Common
					render={({ flags, prefs, labels }) => {
						const ePricePendingLabel = labels.get(EPRICE_PENDING);
						const buttonMobileClass =
							prefs.showLoanLeasePricing === 'true'
								? 'mb-4'
								: 'mb-0';
						const instantEpricePreventMultipleEpriceLeads =
							prefs.instantEpricePreventMultipleEpriceLeads ===
							'true';
						const instantEPriceContainer =
							pricing.detail.ePrice &&
							// compare request account and vehicle account equality to determine
							// whether a vehicle is off-site
							(prefs.showInstantEpriceForSharedInventory !==
								'false' ||
								accountId === vehicleAccountId) ? (
								<InstantEPrice
									showEPrice={this.showEPrice}
									isDisplayingEprice={
										this.state.isDisplayingEprice
									}
									instantEpriceShowAllAfterLeadSubmit={
										prefs.instantEpriceShowAllAfterLeadSubmit
									}
									ePriceDetail={pricing.detail.ePrice}
									buttonLabel={pricing.ePriceButtonLabel}
									pendingLabel={ePricePendingLabel}
									widgetInfo={{
										...widgetInfo,
										windowId,
										widgetName
									}}
									buttonStyle={prefs.buttonStyleEPrice}
									buttonMobileClass={buttonMobileClass}
									preventMultipleEpriceLeads={
										instantEpricePreventMultipleEpriceLeads
									}
									isMobile={isMobile}
									disabled={disableInstantEpriceButton}
								/>
							) : null;

						const isFinalPriceFlagEnabled =
							flags[
								'ws-detailed-pricing.use-final-price-for-instant-eprice'
							] === true;

						// Toggles the display of the pricing summary on mobile
						const showMobilePricingSummary =
							flags['ws-detailed-toggle-summary-pricing'] ===
							true;

						const DDCExists =
							typeof window !== 'undefined' &&
							typeof window.DDC !== 'undefined';

						let drEnable = false;
						/* eslint no-undef: 0 */
						if (DDCExists && DDC.getSiteProperty) {
							drEnable = DDC.getSiteProperty(
								prefs.paymentCalculatorButtonDisplayCondition
							);
						}
						return (
							<div>
								<PricingDetail
									detail={pricing.detail[detailType]}
									detailType={detailType}
									widgetInfo={{
										windowId,
										widgetName,
										deviceType,
										vehicleType
									}}
									prefs={prefs}
									setModalStateData={this.setModalStateData}
									incentiveData={incentiveData}
									locale={locale}
									dealerAddress={dealerAddress}
									isFinalPriceFlagEnabled={
										isFinalPriceFlagEnabled
									}
								/>
								<PricingSummaryContainer
									summary={summary}
									prefs={prefs}
									dealerAddress={dealerAddress}
									showMobilePricingSummary={
										showMobilePricingSummary
									}
									widgetInfo={{
										windowId,
										widgetName,
										deviceType
									}}
								/>
								{instantEPriceContainer}
								{/* Remove showLoanLeasePricing once the summary undergoes IDC treatment */}
								{loanLeaseSummary.length > 0 &&
									prefs.showLoanLeasePricing === 'true' && (
										<PricingLoanLease
											summary={loanLeaseSummary}
											isMobile={isMobile}
											isScrollingSidebar={
												this.state.isScrollingSidebar
											}
										/>
									)}
								{drEnable && (
									<PaymentCalculatorButton
										isLoanLeaseAvailable={
											loanLeaseSummary.length > 0 &&
											prefs.showLoanLeasePricing ===
												'true'
										}
										isScrollingSidebar={
											this.state.isScrollingSidebar
										}
										isMobile={isMobile}
										prefs={prefs}
										labels={labels}
									/>
								)}
								{isMobile ? mobileDialog : regularDialog}
							</div>
						);
					}}
				/> // Common
			);
		}
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	pricing: PropTypes.shape({
		detail: PropTypes.shape({
			dPrice: PropTypes.arrayOf(
				PropTypes.shape({
					_type: PropTypes.string.isRequired,
					formatted: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
					value: PropTypes.number.isRequired,
					incentives: PropTypes.arrayOf(PropTypes.string)
				})
			).isRequired,
			ePrice: PropTypes.arrayOf(
				PropTypes.shape({
					_type: PropTypes.string.isRequired,
					formatted: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
					value: PropTypes.number.isRequired,
					incentives: PropTypes.arrayOf(PropTypes.string)
				})
			)
		}),
		summary: PropTypes.arrayOf(
			PropTypes.shape({
				_type: PropTypes.string.isRequired,
				formatted: PropTypes.string.isRequired,
				label: PropTypes.string.isRequired,
				value: PropTypes.number.isRequired
			})
		),
		ePriceButtonLabel: PropTypes.string.isRequired
	}),
	incentiveData: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			label: PropTypes.string,
			offerDetails: PropTypes.string,
			shortTitle: PropTypes.string,
			effectiveDate: PropTypes.string,
			expirationDate: PropTypes.string,
			conditional: PropTypes.bool,
			error: PropTypes.string
		}).isRequired
	).isRequired,
	widgetInfo: PropTypes.shape({
		vehicleId: PropTypes.string.isRequired,
		vehicleCategory: PropTypes.string.isRequired,
		vehicleType: PropTypes.string.isRequired,
		pageAlias: PropTypes.string.isRequired
	}).isRequired,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired,
	deviceType: PropTypes.string.isRequired,
	locale: PropTypes.string,
	dealerAddress: PropTypes.shape({
		address1: PropTypes.string,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		country: PropTypes.string
	})
};

WidgetContainer.defaultProps = {
	pricing: [],
	locale: 'en_US',
	dealerAddress: {}
};

const mapStateToProps = state => {
	return {
		pricing: state.pricing,
		widgetInfo: state.widgetInfo,
		incentiveData: state.incentive.incentiveData,
		windowId: state.requestData.windowId,
		widgetName: state.requestData.widgetName,
		deviceType: state.requestData.deviceType,
		locale: state.requestData.locale,
		dealerAddress: state.dealerAddress
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx